module.exports = __webpack_public_path__ + "img/address1.804eb931.png";